<template>
    <div class="storeItemDetail">

        <dialogPlugin :showProduct.sync='showProduct' :onlineItems="onlineItems" />
        <div class="check_Top">
            <div class="check_desc">
                <span class="sec_item">
                    {{ $t('other.a1745') }}
                </span>
                <div>

                    <el-button @click="goBack()" type="primary"><i class="iconfont icon-fanhui-"></i>
                        {{ $t('other.a605') }}</el-button>
                </div>
            </div>
        </div>

        <Qrcode-Dialog :instockdia.sync="instockdia" :maincusCode="maincusCode" />
        <Qrcode-Dialog :openBoundDetail.sync="openBoundDetail" :boundProductList="boundProductList" />

        <!-- 产品列表 -->

        <div v-if="!fromCommuity" style="margin-top:70px;padding:0 20px">
            <div class="basic_info">
                <div class="title">{{ $t('other.a735') }}
                    <i class="el-icon-edit"></i>
                </div>
                <div class="basic_detail">
                    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item :label="$t('other.a66')">
                            <el-upload class="avatar-uploader" :headers="token"
                                action="https://erp.weanaly.com/service/access/upload" :show-file-list="false"
                                :on-success="handleAvatarSuccess">
                                <img v-if="ruleForm.image" :src="ruleForm.image" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>

                        </el-form-item>
                        <el-form-item :label="$t('other.a2899')" prop="groupName">
                            <span v-if="!showMoreDetail && !ruleForm.outChecked">{{ ruleForm.groupName }}</span>
                            <el-input v-if="!showMoreDetail && ruleForm.outChecked" v-model="ruleForm.groupName"
                                placeholder=""></el-input>
                            <span v-if="showMoreDetail">{{ ruleForm.groupName }}</span>
                        </el-form-item>

                        <el-form-item :label="$t('other.a2900')" prop="itemSku">
                            <span v-if="!showMoreDetail && !ruleForm.outChecked" style="width:300px">{{ ruleForm.itemSku
                                }}</span>
                            <el-input v-if="!showMoreDetail && ruleForm.outChecked" v-model="ruleForm.itemSku"
                                placeholder=""></el-input>
                            <span v-if="showMoreDetail">{{ ruleForm.itemSku }}</span>
                        </el-form-item>

                        <!-- <el-form-item v-if="!ruleForm.outChecked"  label="商品类目:" prop="itemSku">
                        <span v-if="!showMoreDetail" style="width:300px" >{{categoryName}}</span>
                       
                    </el-form-item> -->





                        <el-form-item v-if="ruleForm.outChecked" :label="$t('other.a1285')" prop="categories">
                            <div v-clickOutSide="handleClose">
                                <el-input v-model="categories" :placeholder="$t('other.a1285')"
                                    @focus="showCaetgory = !showCaetgory"></el-input>
                                <div v-if="showCaetgory" class="cateGory_wrapper">
                                    <ul class="first_wrapper">
                                        <div class="category_title">{{ $t('other.a482') }}</div>
                                        <li class="first_category active" v-for="(item, index) in categoryList"
                                            :key="index" @click="cateGory(item, 1)">
                                            <span>{{ item.categoryName }} </span>
                                        </li>
                                    </ul>
                                    <ul v-if="secondCategory.length" class="second_wrapper">
                                        <div class="category_title">{{ $t('other.a483') }}</div>
                                        <li class="second_category  active"
                                            v-for="(itemTwo, indexOne) in secondCategory" :key="indexOne"
                                            @click="cateGory(itemTwo, 2)">
                                            <span> {{ itemTwo.categoryName }}</span>
                                        </li>
                                    </ul>
                                    <ul v-if="thiryCategory.length" class="three_wrapper">
                                        <div class="category_title">{{ $t('other.a484') }}</div>
                                        <li class="three_category  active"
                                            v-for="(itemThree, indexOne) in thiryCategory" :key="indexOne"
                                            @click="cateGory(itemThree, 3)">
                                            <span>{{ itemThree.categoryName }} </span>

                                        </li>
                                    </ul>
                                    <ul v-if="fourCategory.length" class="three_wrapper">
                                        <div class="category_title"> {{ $t('other.a1378') }}</div>
                                        <li class="three_category  active" v-for="(itemFour, indexOne) in fourCategory"
                                            :key="indexOne" @click="cateGory(itemFour, 4)">
                                            <span>{{ itemFour.categoryName }} </span>

                                        </li>
                                    </ul>
                                    <ul v-if="fiveCategory.length" class="three_wrapper">
                                        <div class="category_title"> {{ $t('other.a1379') }}</div>
                                        <li class="three_category  active" v-for="(itemFive, indexOne) in fiveCategory"
                                            :key="indexOne" @click="cateGory(itemFive, 5)">
                                            <span>{{ itemFive.categoryName }} </span>

                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </el-form-item>

                    </el-form>
                </div>


            </div>
            <div class="basic_info">
                <div class="title">{{ $t('other.a2139') }}</div>
                <div class="basic_detail">
                    <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">

                        <el-form-item label="" prop="name">
                            <el-table :data="ruleForm.storeItems" :show-header="false" border>
                                <el-table-column>
                                    <template slot-scope="props">
                                        <div class="pic_box">
                                            <img style="width:100%" :src="props.row.image" />
                                        </div>
                                        <div style="font-size:18px;padding:8px 0">{{ $t('other.a736') }}：{{
                                            props.row.skuName }}
                                        </div>
                                        <div style="font-size:18px;padding:8px 0">cusCode：{{ props.row.cusCode }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column>
                                    <template slot-scope="props">
                                        <div>{{ $t('other.a2538') }}：{{ props.row.auditedStock }}</div>
                                        <div>{{ $t('other.a2539') }}：{{ props.row.unShipped }}</div>
                                        <div>{{ $t('other.a1037') }}：{{ props.row.stock }}</div>
                                        <div>{{ $t('other.a2540') }}：{{ props.row.reservedStockTotal }}</div>
                                        <div>{{ $t('other.a250') }}{{ props.row.storeNum }}</div>
                                        <div v-show="showMoreDetail" style="display:flex">{{ $t('other.a2546') }}：
                                            <el-switch style="display: block" @change="updateShopeeItem(props.row)"
                                                v-model="props.row.synchrony" active-color="#13ce66"
                                                inactive-color="#ff4949" :active-text="$t('userStoreItems').on"
                                                :inactive-text="$t('userStoreItems').off">
                                                >
                                            </el-switch>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column>
                                    <template slot-scope="props">
                                        <div>{{ $t('other.a1255') }}(cm)：{{ props.row.packageLength }}</div>
                                        <div>{{ $t('other.a1256') }}(cm)：{{ props.row.packageWidth }}</div>
                                        <div>{{ $t('other.a1257') }}(cm)：{{ props.row.packageHeight }}</div>
                                        <div>{{ $t('other.a1516') }}(kg)：{{ props.row.weight }}</div>
                                        <div>{{ $t('other.a1169') }}：{{ props.row.address }}</div>
                                        <div>{{ $t('other.a219') }}：
                                            <span v-show="!props.row.checked">￥{{ showMoreDetail ?
                                                props.row.children[0].price : props.row.cost }}</span>
                                            <span v-show="props.row.checked"><el-input style="width:100px" size="mini"
                                                    v-model="props.row.cost"></el-input></span>
                                        </div>



                                    </template>
                                </el-table-column>
                                <el-table-column>
                                    <template slot-scope="props">
                                        <div class="btn"><el-button style="min-width:150px" size="mini" type="primary"
                                                v-show="showMoreDetail" @click="viewBoundInfo(props.row)">{{
                                                    $t('other.a2395') }}</el-button></div>
                                        <div class="btn"><el-button style="min-width:150px" size="mini" type="primary"
                                                @click="viewstoreoperaterecord(props.row)">{{ $t('other.a2558')
                                                }}</el-button>
                                        </div>
                                        <div class="btn"><el-button style="min-width:150px" size="mini" type="primary"
                                                v-show="!showMoreDetail"
                                                @click="transFormStock(props.row.cusCode, props.row.storeNum, props.$index)">{{
                                                    $t('other.a2901') }}</el-button>
                                        </div>
                                        <!-- <div class="btn">
                                        <el-button v-show="!props.row.checked" style="min-width:150px" size="mini" type="primary" @click="changePrice(props.row.cusCode,props.$index)">修改供货价</el-button>
                                        
                                    </div> -->
                                        <div><el-button v-show="props.row.checked" style="min-width:150px" size="mini"
                                                type="danger" @click="changePriceCopy(props.row, props.$index)">{{
                                                    $t('other.a2902') }}</el-button>
                                        </div>
                                        <div class="btn"><el-button style="min-width:150px" size="mini" type="primary"
                                                @click="deleStoreItem(props.row.cusCode, props.$index)">{{
                                                    $t('other.a312')
                                                }}</el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>


                        </el-form-item>

                    </el-form>
                </div>
            </div>

        </div>


        <!-- 公共产品 -->

        <div v-if="fromCommuity" style="margin-top:47px;padding:2px 20px">
            <div class="basic_info">
                <div class="title">{{ $t('other.a2903') }}</div>
                <div class="basic_detail">
                    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item :label="$t('other.a289')">
                            <div class="community_box">
                                <span v-for="(img, once) in communityList.images" :key="once">
                                    <!-- <img :src="img.image"
                                        class="avatar"> -->
                                    <el-image class="avatar" :src="img.image"
                                        :preview-src-list="communityList.images.map((item) => item.image)">
                                    </el-image>
                                </span>
                            </div>
                        </el-form-item>
                        <el-form-item :label="$t('other.a2904')" prop="groupName">
                            <el-input type="text" :placeholder="$t('other.a319')" v-model="communityList.name">
                            </el-input>
                        </el-form-item>
                        <el-form-item :label="$t('other.a2905')" prop="itemSku">
                            <el-input type="textarea" autosize :placeholder="$t('other.a319')"
                                v-model="communityList.description">
                            </el-input>
                        </el-form-item>

                    </el-form>
                </div>


            </div>
            <div class="bootem" @click="openicon">
                <img src="../../../assets/img/gwc.png" style="width:45px;height:45px" />
                <div class="icon">
                    <el-badge :value="iconData.length" class="item" :hidden="iconData.length == 0">

                    </el-badge>
                </div>
            </div>
            <div class="basic_info">
                <div class="title">{{ $t('other.a2473') }}</div>
                <div class="basic_detail">
                    <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
                        <el-form-item label="" prop="name">
                            <el-table :data="ruleForm.storeItems" border>

                                <el-table-column prop="outTradeNo" :label="$t('other.a217')" width="80">
                                    <template slot-scope="props">
                                        <img class="picBox" slot="reference" :src="props.row.image"
                                            style="width: 50px; height: 50px" />

                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('other.a1251')">
                                    <template slot-scope="props">
                                        <div style="font-size:18px;padding:8px 0">{{ props.row.modelData.variationSku }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('other.a2906')">
                                    <template slot-scope="props">
                                        <div>{{ getVipPirice(props.row) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="一级价" v-if="isSuper">
                                    <template slot="header" slot-scope="scope">
                                        <div>一级价</div>
                                        <el-button type="text" size="mini" @click="openSetPrice(true, 1)">
                                            批量设置价格
                                        </el-button>
                                    </template>
                                    <template slot-scope="props">
                                        <el-button type="text"
                                            @click="openSetPrice(false, props.row.superVipPrice, props.row.cusCode, props.row.groupId, 1)">{{
                                                props.row.superVipPrice ? props.row.superVipPrice :
                                                    '-' }}</el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column label="二级价" v-if="isSuper">
                                    <template slot="header" slot-scope="scope">
                                        <div>二级价</div>
                                        <el-button type="text" size="mini" @click="openSetPrice(true, 0)">
                                            批量设置价格
                                        </el-button>
                                    </template>
                                    <template slot-scope="props">
                                        <el-button type="text"
                                            @click="openSetPrice(false, props.row.vipPrice, props.row.cusCode, props.row.groupId, 0)">{{
                                                props.row.vipPrice ? props.row.vipPrice : '-'
                                            }}</el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('other.a301')">
                                    <template slot-scope="props">
                                        <div>{{ props.row.grossProfitRate }}%</div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('other.a1716')">
                                    <template slot-scope="props">
                                        <div>{{ props.row.storeNum }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('other.a1464')">
                                    <template slot-scope="props">
                                        <div>{{ props.row.wholesalePrice }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('other.a33')">
                                    <template slot-scope="scope">
                                        <el-button size="mini" type="primary"
                                            @click="handleEdit(scope.$index, scope.row)">{{ $t('other.a2907')
                                            }}</el-button>

                                    </template>
                                </el-table-column>
                            </el-table>

                        </el-form-item>

                    </el-form>
                </div>

            </div>

            <div class="basic_info">
                <div class="title">{{ $t('other.a85') }}</div>
                <div class="basic_detail">
                    <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
                        <el-form-item :label="$t('other.a2908')" v-if="communityList.logistics.length > 0" prop="name">
                            <div>
                                <span v-show="it.enabled" v-for="(it, index12) in communityList.logistics"
                                    :key="index12">{{
                                        it.logisticName }}</span>

                            </div>
                        </el-form-item>
                        <el-form-item :label="$t('other.a2909')" prop="name">
                            <span>{{ communityList.packageLength }}</span> X
                            <span>{{ communityList.packageWidth }}</span> X
                            <span>{{ communityList.packageHeight }}</span>
                            cm
                        </el-form-item>
                        <el-form-item :label="$t('other.a2910')" prop="name">
                            <span>{{ communityList.weight }} kg</span>
                        </el-form-item>
                    </el-form>

                </div>
            </div>

        </div>
        <el-dialog :title="$t('other.a2911')" :visible.sync="iconstatus" width="80%">
            <el-table :data="iconData" border max-height="550" style="width: 100%">
                <el-table-column :label="$t('other.a1374')">
                    <template slot-scope="scope">
                        <div v-if="scope.row.userStoreItem.image != null">
                            <el-popover placement="top" title="" trigger="hover">
                                <img :src="scope.row.userStoreItem.image" style="width: 280px; hright: 280px" />
                                <img slot="reference" :src="scope.row.userStoreItem.image"
                                    :alt="scope.row.userStoreItem.image" style="max-height: 90px; max-width: 120px" />
                            </el-popover>
                        </div>
                        <div v-else>
                            {{ $t('other.a2912') }}
                        </div>
                        <!-- <div class="pic_box">
                <img style="width: 100%" :src="scope.row.image" />
              </div> -->
                    </template>
                </el-table-column>
                <el-table-column prop="userStoreItem.skuName" :label="$t('other.a1251')" width="180">
                </el-table-column>
                <el-table-column prop="userStoreItem.wholesalePrice" :label="$t('other.a1464')">
                </el-table-column>
                <!-- <el-table-column
      prop="userStoreItem.storeNum"
      :label="$t('other.a1716')">
    </el-table-column> -->
                <el-table-column prop="userStoreItem.userId" :label="$t('other.a711')">
                </el-table-column>
                <el-table-column :label="$t('other.a1120')" width="220">
                    <template slot-scope="scope">
                        <div class="order_time">{{ $t('other.a1399') }}：{{ scope.row.userStoreItem.packageLength }}
                        </div>
                        <div class="order_time">{{ $t('other.a1400') }}：{{ scope.row.userStoreItem.packageWidth }}</div>
                        <div class="order_time">{{ $t('other.a1401') }}：{{ scope.row.userStoreItem.packageHeight }}
                        </div>
                        <div class="order_time">{{ $t('other.a1168') }}：{{ scope.row.userStoreItem.weight }}</div>


                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a33')">
                    <template slot-scope="scope">

                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">{{
                            $t('other.a312') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="iconstatus = false">{{ $t('other.a106') }}</el-button>
                <el-button @click="deletecart">{{ $t('other.a2913') }}</el-button>
                <el-button type="primary" @click="iconsucced">{{ $t('other.a2914') }}</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="isBatch ? '批量修改价格' : '修改价格'" :visible.sync="dialogPriceVisible" width="30%"
            :before-close="handleClose">
            <el-input v-model="priceNum" type="number" placeholder="请输入价格"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogPriceVisible = false">{{ $t('other.a106') }}</el-button>
                <el-button type="primary" @click="SetPrice">{{ $t('other.a279') }}</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import utils from '../../../utils/utils'
import api from '../../../api/api'
import userStoreItemsApi from '../../../api/moudles/userStoreItems'
import QrcodeDialog from '../../../components/dialog/qrcodeDialog.vue'
import mygoods from '../../../api/moudles/mygoods'
import dialogPlugin from '../../stockProduct/component/diaload'
export default {
    data() {
        return {
            iconstatus: false,
            iconvalue: 0,
            iconData: [],
            stores: JSON.parse(localStorage.getItem('userInfo')).stores,
            storesOptions: [],
            overDataList: [],

            showCaetgory: false,
            fromCommuity: false,
            categoryList: [],
            secondCategory: [],
            categoryIdList: [],
            tableData: [],
            communityList: [],
            targetCusCode: '',
            Quity: null,
            targetNum: 0,
            thiryCategory: [],
            fourCategory: [],
            fiveCategory: [],
            boundProductList: [],
            dialogVisible: false,
            cateList: [],
            targetIndex: 0,
            categories: '',
            sourceCusCode: '',
            dialogVisible: false,
            showMoreDetail: false,
            openBoundDetail: false,
            stockValue: '',
            onlineItems: {},
            active: 0,
            overDataTotal: 0,
            showProduct: false,
            totalStockNum: {},
            currentPage: 1,
            targetList: [],
            categoryName: '',
            objStock: {},
            imageUrl: '',
            dataParams: {
                component: true,
                cusCode: "",
                offset: 50,
                page: 0,
                sellerId: JSON.parse(localStorage.getItem('userInfo')).userId,
                storeId: null,
                userId: JSON.parse(localStorage.getItem('userInfo')).userId,
            },
            ruleForm: {
                groupName: '',
                categoryId: null,
                itemSku: '',
                storeItems: []
            },
            token: {
                token: JSON.parse(localStorage.getItem('userInfo')).token
            },
            instockdia: false,
            maincusCode: 0,
            dialogPriceVisible: false,
            priceNum: null,
            checkInfo: {},
            isBatch: false,
        }
    },

    components: {
        QrcodeDialog,
        dialogPlugin

    },

    computed: {
        ...mapState({
            userName: (state) => state.shopaccess.userInfo.userName,
            userId: (state) => state.shopaccess.userInfo.userId,
            isSuper: (state) => state.shopaccess.userInfo.isSuper,
            distributorLevel: (state) => state.shopaccess.userInfo.distributorLevel,
        }),
        targetListCopy() {
            let list = this.targetList.filter(p => {
                if (p.checked) {
                    return p
                }
            })

            return list

        }





    },
    directives: {
        clickOutSide: {
            bind: function (el, binding, vnode) {
                function documentHandler(e) {
                    if (el.contains(e.target)) {
                        return false
                    }

                    if (binding.expression) {
                        binding.value(e)
                    }
                }
                el._vueClickOutside_ = documentHandler
                document.addEventListener('click', documentHandler)
            },

            unbind: function (el, binding) {
                document.removeEventListener('click', el._vueClickOutside_)
            }

        },
        el_selectLoadmore: {
            bind(el, binding) {
                let self = this
                const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')

                SELECTWRAP_DOM.addEventListener('scroll', function () {
                    const condition = this.scrollHeight - this.scrollTop - 20 <= this.clientHeight
                    if (condition) binding.value()
                })
            }
        }
    },
    watch: {
        dialogVisible() {
            if (!this.dialogVisible) {
                this.totalStockNum = {}
            }
        }

    },


    created() {
        this.init()
        this.changerProduct()
        this.getCart()

    },
    destroyed() {
        // utils.cleanStorageData()
    },
    methods: {
        ...mapActions('userStoreItems', [
            'getInstockoperaterecore',
            'deleStoreItems'

        ]),
        openSetPrice(status, num, cusCode, groupId, type) {
            this.isBatch = status;
            if (status) {
                this.priceNum = null;
                this.checkInfo = {
                    type: num,
                    groupId: null,
                }
            } else {
                this.priceNum = num;
                this.checkInfo = {
                    cusCode: cusCode,
                    type: type,
                    groupId, groupId,
                }
            }
            this.dialogPriceVisible = true;

        },
        SetPrice() {
            if (this.isBatch) {
                for (let i = 0; i < this.ruleForm.storeItems.length; i++) {
                    let formData = new FormData();
                    formData.append('userId', this.userId);
                    formData.append('price', this.priceNum);
                    formData.append('cusCode', this.ruleForm.storeItems[i].cusCode);
                    formData.append('type', this.checkInfo.type);
                    userStoreItemsApi.updatePriceByCusCode(formData).then(res => {
                        console.log(res)
                        if (res.code == 200) {
                            if (i == this.ruleForm.storeItems.length - 1) {
                                this.checkInfo.groupId = this.ruleForm.storeItems[i].groupId
                                this.$message.success(res.msg)
                                this.dialogPriceVisible = false
                                this.getStoreItemDetail()
                            }
                        } else {
                            this.$message.warning(res.msg)
                        }
                    })
                }
            } else {
                let formData = new FormData();
                formData.append('userId', this.userId);
                formData.append('price', this.priceNum);
                formData.append('cusCode', this.checkInfo.cusCode);
                formData.append('type', this.checkInfo.type);
                userStoreItemsApi.updatePriceByCusCode(formData).then(res => {
                    console.log(res)
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.dialogPriceVisible = false
                        this.getStoreItemDetail()
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            }
        },
        getStoreItemDetail() {
            api
                .getStoreItemByGroupId({ groupId: this.checkInfo.groupId })
                .then(res => {
                    if (res.code === 200) {
                        console.log('详情信息', res.data)
                        let list = []
                        if (res.data.storeItems) {
                            res.data.storeItems.forEach(p => {
                                if (p.putAway) {
                                    list.push(p)
                                }
                            })
                        }

                        res.data.storeItems = list

                        localStorage.setItem('storeItemDetail', JSON.stringify(res.data))
                        location.reload();
                    } else {
                        this.message.warning(res.msg)
                    }
                })
        },
        getVipPirice(item) {
            let price = null
            if (this.isSuper) {
                price = item.price
            } else {
                if (this.distributorLevel == 0) {
                    price = item.vipPrice ? item.vipPrice : item.price
                } else if (this.distributorLevel == 1) {
                    price = item.superVipPrice ? item.superVipPrice : item.price
                }
            }
            return price
        },
        getCart() {
            let params = {
                partnerId: 0,
                userId: this.userId
            }
            api
                .getcart(params)
                .then(res => {
                    if (res.code == 200) {

                        console.log(res)
                        this.iconData = res.data
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        },
        deletecart() {
            console.log(this.iconData)
            let obj = {
                partnerId: 0,
                userId: this.userId,
                userShoppingCarts: []
            }
            let arrnew = this.iconData.map((item, index) => {
                return Object.assign(
                    {},
                    {
                        cuscode: item.cuscode,
                        userId: item.userId
                    }
                );
            });
            obj.userShoppingCarts = arrnew
            console.log(obj)
            api
                .removecart(obj)
                .then(res => {
                    if (res.code == 200) {
                        console.log(res)
                        this.getCart();
                        //this.iconData = res.data
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        },
        iconsucced() {
            this.$router.push({
                path: '/purchuseListcart'

            })
        },
        handleDelete(index, row) {

            console.log(row)
            let obj = {
                partnerId: 0,
                userId: this.userId,
                userShoppingCarts: [
                    {
                        cuscode: 0,
                        groupId: 0,
                        userId: this.userId
                    }
                ]
            }
            obj.userShoppingCarts[0].cuscode = row.cuscode
            obj.userShoppingCarts[0].groupId = row.groupId
            console.log(obj)
            // this.iconData.push(row)
            api
                .removecart(obj)
                .then(res => {
                    if (res.code == 200) {

                        console.log(res)
                        this.getCart();
                        //   this.iconData = res.data
                    } else {
                        this.$message.warning(res.msg)
                    }
                })

        },
        openicon() {
            this.iconstatus = true
        },
        handleEdit(index, row) {
            console.log(row)
            let obj = {
                partnerId: 0,
                userId: this.userId,
                userShoppingCarts: [
                    {
                        cuscode: 0,
                        groupId: 0,
                        userId: this.userId
                    }
                ]
            }
            obj.userShoppingCarts[0].cuscode = row.cusCode
            obj.userShoppingCarts[0].groupId = row.groupId
            console.log(obj)
            // this.iconData.push(row)
            api
                .addcart(obj)
                .then(res => {
                    if (res.code == 200) {

                        console.log(res)
                        this.getCart();
                        //   this.iconData = res.data
                    } else {
                        this.$message.warning(this.$t('other.a2915'))
                    }
                })
            // console.log(this.iconData)

        },
        updateShopeeItem(item) {
            item.synchrony = !item.synchrony
            if (!item.synchrony) {
                let text = this.$t('other.a2599')
                this.$confirm(text, this.$t("other.a142"), {
                    confirmButtonText: this.$t('other.a763'),
                    cancelButtonText: this.$t('other.a146'),
                    type: 'warning'
                }).then(() => {
                    let ttp = JSON.parse(JSON.stringify(item))
                    ttp.synchrony = true
                    userStoreItemsApi
                        .sellerUpdateSynchrony(ttp)
                        .then(res => {
                            if (res.code === 200) {
                                console.log('desc', res.data)
                                this.$message.success(this.$t('other.a2600'))
                                item.synchrony = true
                            } else {
                                this.$message.warning(res.msg)
                            }
                        })

                })
            } else {
                let text = this.$t('other.a2601')
                this.$confirm(text, this.$t("other.a142"), {
                    confirmButtonText: this.$t('other.a5'),
                    cancelButtonText: this.$t('other.a146'),
                    type: 'warning'
                }).then(() => {
                    let ttp = JSON.parse(JSON.stringify(item))
                    ttp.synchrony = false
                    userStoreItemsApi
                        .sellerUpdateSynchrony(ttp)
                        .then(res => {
                            if (res.code === 200) {
                                console.log('desc', res.data)
                                this.$message.success(this.$t('other.a2602'))
                                item.synchrony = false
                            } else {
                                this.$message.warning(res.msg)
                            }
                        })
                })
            }


        },

        getStoreItem() {

            api
                .batchTransferStoreNum([{
                    num: 200,
                    sourceCusCode: 20305719,
                    targetCusCode: 20319966,
                    userId: this.userId,
                }])
                .then(res => {
                    if (res.code === 200) {
                        console.log('desc', res.data)
                        this.$message.warning('11111')

                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        },

        calcNum(item) {
            item.storeNum = this.totalStockNum.storeNum - (item.stock - this.totalStockNum.stock)

        },

        changProductInfo() {

            this.ruleForm.outChecked = true
        },


        saveCateGoryID() {
            console.log(this.ruleForm)
            userStoreItemsApi
                .updateGroup(this.ruleForm)
                .then(res => {
                    if (res.code === 200) {
                        console.log('desc', res.data)
                        this.$message.success(this.$t('other.a993'))

                        this.categoryName = this.categories
                        this.ruleForm.outChecked = false
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        },

        handleClose() {
            this.showCaetgory = false
            this.dialogPriceVisible = false
        },

        cateGory(item, index) {

            console.log(item, index)
            if (index == 1) {
                this.secondCategory = item.childrens
                this.thiryCategory = []
                this.cateList[index - 1] = item.categoryName
                this.categoryIdList[index - 1] = item.categoryId
                this.cateList.splice(index, 1)
                this.categoryIdList.splice(index, 1)

            } else if (index == 2) {
                this.thiryCategory = item.childrens
                this.cateList[index - 1] = item.categoryName
                this.categoryIdList[index - 1] = item.categoryId
                this.cateList.splice(index, 1)
                this.categoryIdList.splice(index, 1)
            } else if (index == 3) {
                this.fourCategory = item.childrens
                this.cateList[index - 1] = item.categoryName
                this.categoryIdList[index - 1] = item.categoryId
                this.categoryIdList.splice(index, 1)
            } else if (index == 4) {
                this.fiveCategory = item.childrens ? item.childrens : []
                this.cateList[index - 1] = item.categoryName
                this.categoryIdList[index - 1] = item.categoryId
                this.categoryIdList.splice(index, 1)
            } else if (index == 5) {
                this.cateList[index - 1] = item.categoryName
                this.categoryIdList[index - 1] = item.categoryId
                this.categoryIdList.splice(index, 1)
            }


            this.categories.slice(index - 1)
            this.cateList.slice(index - 1)
            this.categoryIdList.slice(index - 1)

            this.categories = this.cateList.join(' / ')
            if (item.childrens == null) {
                this.showCaetgory = false
                this.thiryCategory = []
                this.fourCategory = []
                this.secondCategory = []
                this.fiveCategory = []


                this.ruleForm.categoryId = this.categoryIdList[this.categoryIdList.length - 1]

            }

            console.log(this.ruleForm.categoryId)


            console.log(this.categoryIdList)
            console.log(this.cateList)
            console.log(this.categories)
        },
        setPrice() {
            this.ruleForm.storeItems.forEach(p => {
                p.cost = this.stockValue
            })
        },
        init() {
            let item = JSON.parse(localStorage.getItem('storeItemDetail'))
            console.log(item)
            item.outChecked = false
            item.storeItems.forEach(p => {
                p.checked = false

            })
            let storeitmes = item

            let baseUrl = this.$route.query.obj
            if (baseUrl) {
                if (baseUrl.indexOf('hasAgent') > -1) {
                    this.showMoreDetail = true
                }
            }

            //分销选品库查看产品详情
            if (this.$route.query.obj === '/publicGoods') {
                this.fromCommuity = true
                api
                    .getProductByproductId({ productId: item.productId })
                    .then(res => {
                        console.log(res)
                        console.log("===111111")
                        if (res.code === 200) {
                            this.communityList = res.data
                            // let setIds = []
                            // storeitmes.storeItems.forEach(p => {
                            //     let mainItem = this.communityList.variations.find(item => item.cusCode == p.cusCode)
                            //     setIds.push(mainItem.cusCode)
                            //     p.modelData = mainItem
                            // })


                            let setArr = []
                            this.communityList.variations.forEach(v => {
                                if (v.storeItem) {
                                    // if (setIds.indexOf(v.cusCode) == -1) {
                                    let obj = v.storeItem;
                                    obj.modelData = v
                                    setArr.push(obj)
                                    // }
                                }
                            }
                            )
                            // storeitmes.storeItems.push(...setArr)
                            storeitmes.storeItems = setArr
                            this.ruleForm = storeitmes
                            console.log('communityList', this.communityList)
                            console.log('ruleForm', this.ruleForm)
                        } else {
                            this.message.warning(res.msg)
                        }
                    })
            }


            if (this.$route.query.groupId && this.$route.query.productId) {
                api
                    .updateProductId({
                        groupId: this.$route.query.groupId,
                        storeId: this.$route.query.productId,
                        productId: this.$route.query.storeId,
                        userId: this.userId
                    })
                    .then(res => {
                        if (res.code === 200) {
                            this.$message.success(this.$t('other.a2916'))
                        } else {
                            this.$message.warning(res.msg)
                        }
                    })
            }
            console.log('111', baseUrl)
        },
        changeModer() {
            this.$router.push({
                path: '/templateManagement',
                query: {
                    flag: 'storeItemDetail',
                    groupId: this.ruleForm.groupId,
                    storeId: this.ruleForm.storeId,
                    obj: this.$route.query.obj
                }
            })
        },
        transFormStock(id, stock, index) {
            this.targetIndex = index
            console.log(stock, index)
            this.dialogVisible = true
            //  this.objStock.sourceCusCode=id


            api
                .getCorrelation([id])
                .then(res => {
                    if (res.code === 200) {
                        console.log('desc', res.data)
                        this.targetCusCode = res.data[0].cusCode
                        this.sourceCusCode = res.data[0].correlation.cusCode

                        this.tableData = [{
                            sourceCusCode: res.data[0].correlation.cusCode,
                            targetCusCode: res.data[0].cusCode,
                            storeNum: res.data[0].correlation.storeNum,
                            stock: stock

                        }]
                        this.totalStockNum = {
                            storeNum: res.data[0].correlation.storeNum,
                            stock: JSON.parse(JSON.stringify(stock))
                        }

                    } else {
                        this.message.warning(res.msg)
                    }
                })
        },

        tranfomr(num) {
            console.log(this.tableData)
            console.log(this.ruleForm)

            this.tableData[0].userId = this.userId
            this.tableData[0].num = this.tableData[0].stock

            if (this.tableData[0].num == this.totalStockNum.stock) {
                return
            }

            if (this.tableData[0].num > this.totalStockNum.stock) {//调入
                let params = {
                    sourceCusCode: this.tableData[0].sourceCusCode,
                    targetCusCode: this.tableData[0].targetCusCode,
                    num: this.tableData[0].num - this.totalStockNum.stock,
                    userId: this.userId

                }

                console.log(params)
                this.targetNum = this.tableData[0].num - this.totalStockNum.stock
                this.batchStock([params])


            } else {
                let params = {
                    targetCusCode: this.tableData[0].sourceCusCode,
                    sourceCusCode: this.tableData[0].targetCusCode,
                    num: this.totalStockNum.stock - this.tableData[0].num,
                    userId: this.userId

                }
                this.targetNum = this.tableData[0].num - this.totalStockNum.stock

                console.log(params)
                this.batchStock([params])
            }




        },

        batchStock(list) {
            api
                .batchTransferStoreNum(list)
                .then(res => {
                    if (res.code === 200) {
                        this.$message.success(this.$t('other.a2874'))
                        console.log(this.targetNum)
                        if (this.targetNum < 0) {//减库存

                            this.ruleForm.storeItems[this.targetIndex].storeNum = this.ruleForm.storeItems[this.targetIndex].storeNum + this.targetNum

                        } else if (this.targetNum > 0) {//增库存
                            this.ruleForm.storeItems[this.targetIndex].storeNum += this.targetNum
                        }

                        this.totalStockNum = {}
                        this.dialogVisible = false
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        },

        changerProduct() {
            let stores = JSON.parse(localStorage.getItem('userInfo')).stores
            let storeId = null

            if (this.ruleForm.storeItems) {

                storeId = this.ruleForm.storeItems[0].storeId

            }



            let conutry = stores.find(item => item.storeId === storeId)
            if (conutry) {
                api
                    .getCategoryByCountry({
                        country: conutry.storeAddress
                    })
                    .then(res => {
                        if (res.code === 200) {
                            console.log('类目', res.data)
                            this.categoryList = res.data
                            this.getDescBycategoryid(res.data)
                        }
                    })
            }




            console.log(this.ruleForm.categoryId)
        },

        //往返找当前产品的类目信息
        getDescBycategoryid(cageGoryList) {
            let list = []
            cageGoryList.forEach(p => {
                list.push(p)
                if (p.childrens) {
                    p.childrens.forEach(k => {
                        list.push(k)
                        if (k.childrens) {
                            k.childrens.forEach(i => {
                                list.push(i)
                                if (i.childrens) {
                                    i.childrens.forEach(j => {
                                        list.push(j)
                                        if (j.childrens) {
                                            j.childrens.forEach(b => {
                                                list.push(b)
                                                if (b.childrens) {
                                                    b.childrens.forEach(r => {
                                                        list.push(r)
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            })

            let obj = list.find(item => item.categoryId === this.ruleForm.categoryId)
            let arr = []
            if (obj) {
                arr.unshift(obj.categoryName)
                if (obj.parentId !== 0) {
                    let b = list.find(item => item.categoryId === obj.parentId)
                    arr.unshift(b.categoryName)
                    if (b.parentId !== 0) {
                        let c = list.find(item => item.categoryId === b.parentId)
                        arr.unshift(c.categoryName)
                        if (c.parentId !== 0) {
                            let d = list.find(item => item.categoryId === c.parentId)
                            arr.unshift(d.categoryName)
                            if (d.parentId !== 0) {
                                let m = list.find(item => item.categoryId === d.parentId)
                                arr.unshift(m.categoryName)
                            }
                        }
                    }
                }
            }

            this.categoryName = arr.join('/')


            console.log('list', list, obj)

            console.log('111', arr)
        },

        goBack() {
            let backUrl = this.$route.query.obj
            this.$router.push(backUrl)
        },
        viewBoundInfo(item) {
            mygoods
                .getBindItems({
                    cusCode: item.cusCode
                })
                .then(res => {
                    if (res.code === 200) {
                        console.log('desc', res.data)
                        this.onlineItems = {
                            sku: item,
                            list: res.data,
                            storeId: this.ruleForm.storeId
                        }
                        this.showProduct = true
                        //  this.openBoundDetail=true
                        //  this.boundProductList=res.data
                    } else {
                        this.$message.warning(res.msg)
                    }
                })

        },

        viewstoreoperaterecord(item) {
            this.instockdia = true
            this.maincusCode = item.cusCode
            let params = {
                cusCode: item.cusCode,
                end: utils.getchinastadarTime(0),
                start: utils.getchinastadarTime(-7),
                offset: 50,
                page: 0,
                userId: this.userId
            }
            console.log(params)
            this.getInstockoperaterecore(params)
        },

        changePriceCopy(item, index) {
            console.log(item)
            item.cost = Number(item.cost)

            api
                .updateStoreItemDetail(item)
                .then(res => {
                    if (res.code === 200) {
                        console.log('desc', res.data)
                        this.$message.success(this.$t('other.a665'))
                        this.ruleForm.storeItems[index].checked = false
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        },

        changePrice(code, index) {
            this.ruleForm.storeItems[index].checked = true
        },

        deleStoreItem(code, index) {
            console.log(index)

            this.$confirm(this.$t('other.a2157'), this.$t("other.a142"), {
                confirmButtonText: this.$t('other.a145'),
                cancelButtonText: this.$t('other.a146'),
                type: 'warning'
            }).then(() => {
                let param = {
                    cusCode: code,
                    userId: this.userId,
                    storeId: this.ruleForm.storeId
                }
                this.deleStoreItems(param).then(res => {
                    if (res.code == 200) {
                        this.$message.success(this.$t('other.a565'))
                        this.ruleForm.storeItems.splice(index, 1)

                    } else {
                        this.$message.warning(res.msg)
                    }

                })

            })

        },

        handleAvatarSuccess() {

        },



    }
}

</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.bootem {
    position: fixed;
    bottom: 300px;
    right: 0;
    background: #fff;
    width: 70px;
    height: 70px;
    display: flex;

    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 50%;
    z-index: 9999;
    cursor: pointer;
}

.bootem:hover {
    background: #cccccc;
}

.icon {
    position: absolute;
    top: 0;

    left: 0;
}

.storeItemDetail {
    // flex: 1;
    // margin: 60px 0 0 228px;
    background-color: rgba(226, 222, 222, 0.5);
    min-height: 100vh;



    /deep/ .el-checkbox__inner {
        width: 20px;
        height: 20px;
    }

    /deep/ .el-checkbox__inner::after {
        height: 10px;
        left: 7px;
        width: 4px;
        font-weight: bold;


    }

    .community_box {
        display: flex;
    }

    .basic_info {

        background-color: #fff;
        padding: 0 16px;
        margin-top: 20px;

        .btn {
            margin: 3px 0;

        }

        .active {
            background-color: #fff !important;
        }

        .active:hover {
            background-color: #eee !important;
        }



        .pic_box {
            width: 80px;
            height: 80px;
            border: 1px solid #eee;
            overflow: hidden;
            border-radius: 5px;
        }



        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }

        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }

        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 120px;
            height: 120px;
            line-height: 120px;

            text-align: center;
            border: 1px dashed #66b1ff;
        }

        .avatar {
            width: 120px;
            height: 120px;
            display: block;
            margin: 5px;
            border: 1px solid #eee;
        }

        .cateGory_wrapper {
            position: relative;
            box-shadow: 0 5px 5px -3px #606266;
            height: 450px;
            display: flex;



            .first_wrapper {

                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;


                .first_category {
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }


            }



            .second_wrapper {

                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;


                .second_category {
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }


            }

            .three_wrapper {

                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;

                .three_category {
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }


            }

            .four_wrapper {
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;

                .four_category {
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }


            }


            .category_title {
                position: relative;
                top: 0;
                left: 0;

            }



            .active:hover {
                background-color: #eee;
            }
        }





        .title {
            height: 40px;
            line-height: 40px;
            font-size: 20px;
            font-weight: 500;
            letter-spacing: .02em !important;
            font-family: Roboto, sans-serif !important;
            border-bottom: 1px solid #eee;
        }

        .basic_detail {
            padding: 15px 0;

        }

    }

    .Pager {
        position: fixed;
        bottom: 0;
        left: 225px;
        right: 0;
        height: 40px;
        line-height: 40px;
        background-color: #fff;
        text-align: right;

    }



    .overseaProduct_list {
        margin-top: 145px;
        display: flex;
        flex-wrap: wrap;



        .overseaProduct_item {
            box-sizing: border-box;
            margin: 8px 5px;
            background-color: #fff;
            border-radius: 5px;

        }





        .title_overseaProduct {
            width: 120px;
            height: 3.5rem;
            text-overflow: ellipsis;
            overflow: hidden;
            padding: 2px;
            font-size: 12px
        }
    }


    .check_desc {
        @include flex-between();
        padding: 5px 30px 5px 0;

        .check_desc_item {
            margin: 0 10px;
        }

        .sec_item {
            @include flex-start()
        }
    }

    .check_desc:nth-child(3) {
        display: flex;
        justify-content: space-between;
        padding-right: 15px;
        align-items: center;
    }


    .check_Top {
        position: fixed;
        z-index: 99;
        top: 50px;
        width: calc(100% - 205px);
        background-color: #fff;
        border-bottom: 1px solid #eee;


    }

    .check_header {
        padding: 10px 15px;
    }

    .check_table {

        margin-top: 105px;
        width: calc(100% - 15px);

        .check_title {
            font-size: 18px;
            font-weight: bold;
            padding: 10px 0;
        }
    }

    .textarea {
        margin-bottom: 100px;
        margin-top: 10px;
    }

}
</style>